import styled from 'styled-components'

import { Headline3 } from '../fonts'

export const Title = styled(Headline3)`
  margin-bottom: 10px;
`
